export { default } from './SimpleMarkdown';



// WEBPACK FOOTER //
// ./src/components/atoms/SimpleMarkdown/index.js